import { Navigate, Route, Routes } from 'react-router-dom'
import HomeLanding from '@/pages/home/HomeLanding'
import HomeProfile from '@/pages/home/HomeProfile'
import MortarCalculator from '@/pages/home/MortarCalculator'
import SupporterMembership from '@/pages/home/SupporterMembership'
import SupporterReturn from '@/pages/home/SupporterReturn'
import { HomeAuthProvider } from '@/contexts/HomeAuthContext'
import { SUPPORTER_ENABLED } from '@/lib/features'

/**
 * The public community site served on turksletloose.com (and www).
 *
 * Same bundle and same nginx as the dashboard and the recruitment site — only
 * the hostname differs (see App.tsx). Unlike JoinApp it now carries a session,
 * but *not* AuthProvider: that one calls /api/auth/me and refuses anyone
 * outside the guild roster. Supporters need not be members, so the site has its
 * own scope and cookie (HomeAuthProvider → /api/home/me, `tll_home`).
 *
 * Signing in is never required to read the site; it gates one thing only, and
 * that is buying a supporter membership.
 *
 * While `SUPPORTER_ENABLED` is off the two selling routes are not registered at
 * all, so /supporter and /vip fall through to the catch-all and land on the
 * landing page — no dead link and no page that offers something we are not
 * selling. /supporter/thanks stays: it is where Whop drops someone who has
 * already paid, and a purchase that was in flight when the switch flipped
 * should still end somewhere that explains itself.
 */
export default function HomeApp() {
  return (
    <HomeAuthProvider>
      <Routes>
        <Route path="/" element={<HomeLanding />} />
        <Route path="/calculator" element={<MortarCalculator />} />
        {SUPPORTER_ENABLED && (
          <Route path="/supporter" element={<SupporterMembership />} />
        )}
        {/* Where Whop returns the buyer. Not linked from anywhere on purpose:
            it is an outcome, not a destination — see SupporterReturn. */}
        <Route path="/supporter/thanks" element={<SupporterReturn />} />
        <Route path="/profile" element={<HomeProfile />} />
        {/* The page lived at /vip first; keep that link working. */}
        {SUPPORTER_ENABLED && (
          <Route path="/vip" element={<Navigate to="/supporter" replace />} />
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HomeAuthProvider>
  )
}
